import { render, staticRenderFns } from "./AdvancedOrderingModal.vue?vue&type=template&id=813e6eb4&"
import script from "./AdvancedOrderingModal.vue?vue&type=script&lang=js&"
export * from "./AdvancedOrderingModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports